import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})

export class OverlayContainer {
    protected containerElement: HTMLElement;

    public getContainerElement(): HTMLElement {
        if (!this.containerElement) {
            this._createContainer();
        }

        return this.containerElement;
    }

    protected _createContainer(): void {
        const container = document.createElement('div');

        container.classList.add('overlay-container');

        document.body.appendChild(container);

        this.containerElement = container;
    }
}
